import { toast } from "react-toastify";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
const csrftoken = getCookie("csrftoken");
export function signin(email, password, code = "fr") {
  return axios({
    url: `auth/token/login/`,
    method: "post",
    xstfCookieName: "csrftoken",
    xsrfHeaderName: "X-CSRFToken",
    data: { email: email, password: password },

    headers: {
      "Content-Type": "application/json",
      "Accept-Language": code,
      "X-CSRFToken": "csrftoken",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // const err = error.toJSON();
      if (error.response.status === 403) {
        toast("Something went wrong try later", { type: "error" });
      } else if (error.response) {
        const data = error.response.data;
        const errors = Object.keys(data).map(
          (k) => `${k.toUpperCase()} Error: ${data[k].join(" ")}`
        );
        toast(errors.join(" "), { type: "error" });
      }
    });
}

export function register(name, email, password, code = "fr") {
  return axios
    .post(
      "auth/users/",
      { name: name, email: email, password: password },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": code,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      //   const err = error.toJSON();
      if (error.response) {
        const data = error.response.data;
        const errors = Object.keys(data).map(
          (k) => `${k.toUpperCase()} Error: ${data[k].join(" ")}`
        );

        toast(errors.join(" "), { type: "error" });
      }
    });
}

export function getAuthenticatedUser(token) {
  return axios
    .get("/auth/users/me", {
      headers: {
        Authorization: token ? `Token ${token}` : "",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
}

export function fetchInsurrances(home, code = "fr") {
  return axios
    .get(`/${code}/api/insurrances/${home ? "home" : ""}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": code,
      },
    })
    .then((response) => {
      const data = response.data;
      return Array.isArray(data) ? data : (data.results ?? []);
    });
}

export function fetchInsurrance(slug, code = "fr") {
  return axios
    .get(`/${code}/api/insurrances/${slug}`, {
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": code,
      },
    })
    .then((response) => {
      return response.data;
    });
}

export function fetchArticles(home, code = "fr") {
  return axios
    .get(`${code}/api/blog/${home ? "home" : ""}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      const data = response.data;
      return Array.isArray(data) ? data : (data.results ?? []);
    });
}

export function fetchArticle(slug, code = "fr") {
  return axios
    .get(`${code}/api/blog/${slug}`, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    });
}

export function contactAPI(data) {
  return axios({
    method: "post",
    url: "/api/contact/",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      //   const err = error.toJSON();
      if (error.response) {
        const data = error.response.data;
        const errors = Object.keys(data).map(
          (k) => `${k.toUpperCase()} Error: ${data[k].join(" ")}`
        );

        toast(errors.join(" "), { type: "error" });
      }
    });
}

export function placeBook(data, token) {
  return axios({
    method: "post",
    url: `/api/booking/`,
    data,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Token ${token}` : "",
    },
  })
    .then((response) => {
      toast.success(
        "Nous avons bien reçu votre réservation, nous allons vous contacter dans les bref délai"
      );
      toast.success(
        "We have received your reservation, we will contact you as soon as possible."
      );
      return response.data;
    })
    .catch((error) => {
      toast("Oops... Something Went Wrong Try later", { type: "error" });
    });
}

export function postInvoice(data) {
  return axios({
    method: "post",
    url: `/api/online-services/invoices/`,
    data,
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      toast.success(
        "Nous avons bien reçu votre demande devis, nous allons vous contacter dans les bref délai"
      );
      toast.success(
        "We have received your invoice request, we will contact you shortly."
      );
      return response.data;
    })
    .catch((error) => {
      toast("Oops... Something Went Wrong Try later", { type: "error" });
    });
}

export function postClaimReport(data) {
  return axios({
    method: "post",
    url: `/api/online-services/claim-report/`,
    data,
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      toast.success(
        "Nous avons bien reçu votre demande de sinistre, nous allons vous contacter dans les bref délais"
      );
      toast.success(
        "We have received your claim report request, we will contact you shortly."
      );
      return response.data;
    })
    .catch((error) => {
      toast("Oops... Something Went Wrong Try later", { type: "error" });
    });
}


export function uploadImage(image) {
  const formData = new FormData();
  formData.append("file", image);
  formData.append("upload_preset", "akoassurance");
  formData.append("cloud_name", "dnfpmrdjl")
  return axios.post("https://api.cloudinary.com/v1_1/dnfpmrdjl/image/upload", formData).then((response) => {
    // console.log(typeof response.data.secure_url);
    return String(response.data.secure_url);
    // return String(response.data);
  });
}